import {
  paramSlotNameCapturePattern,
  paramSlotPlaceholderPattern,
} from '@terra/shared-asset-processing';
import { z } from 'zod';

const HAS_PARAM_PLACEHOLDER_PATTERN = paramSlotPlaceholderPattern('i');
const PARAM_SLOT_NAME_CAPTURE_PATTERN = paramSlotNameCapturePattern('gi');

export const ParamConfidenceSchema = z.object({
  param: z.string(),
  confidence: z
    .number()
    .min(0, 'paramConfidence must be at least 0')
    .max(1, 'paramConfidence must be at most 1'),
});

export type ParamConfidence = z.infer<typeof ParamConfidenceSchema>;

export const ParameterizedPathLineSchema = z.object({
  pattern: z
    .string()
    .trim()
    .min(1, 'pattern must not be empty')
    .refine((value) => value.startsWith('/'), 'pattern must start with /')
    .refine(
      (value) => HAS_PARAM_PLACEHOLDER_PATTERN.test(value),
      'pattern must contain at least one {param} placeholder',
    ),
  paramConfidences: z
    .array(ParamConfidenceSchema)
    .min(1, 'paramConfidences must contain at least one value'),
});

export type ParameterizedPathLine = z.infer<typeof ParameterizedPathLineSchema>;

export function paramNamesFromPattern(pattern: string): readonly string[] {
  return [...pattern.matchAll(PARAM_SLOT_NAME_CAPTURE_PATTERN)].map(
    (match) => match[1],
  );
}

export function countParamPlaceholders(pattern: string): number {
  return paramNamesFromPattern(pattern).length;
}

export function hasParamPlaceholder(value: string): boolean {
  return HAS_PARAM_PLACEHOLDER_PATTERN.test(value);
}
